import Skill from "./Skill";

export default class SkillCategory {
  constructor(data) {
    this.name = data.name;
    this.skills = Array.isArray(data.skills)
      ? data.skills.map(e => new Skill(e))
      : [];
  }

  get numSkills() {
    return this.skills.length;
  }
}
